const buildErrorMsg = (text: string, fieldName: string) => {
  const field = fieldName.replace(":", "");
  return text.replace("{fieldName}", field);
};

export default buildErrorMsg;
